import { render, staticRenderFns } from "./UploadDoc.vue?vue&type=template&id=0d3908bc"
import script from "./UploadDoc.vue?vue&type=script&lang=js"
export * from "./UploadDoc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports